<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/audit-intern/table">实习生管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-tabs v-model="activeTab" type="border-card">
      <el-tab-pane label="基础资料"
                   v-if="allowViewEditBase()"
                   name="baseInfo">
        <layout-panel :show-header="false">
          <el-form ref="baseForm"
                   class="form-content-half"
                   :model="baseForm"
                   :rules="baseFormRules"
                   size="medium"
                   label-width="140px"
                   @submit.native.prevent="onSubmitBase()">
            <base-info-form ref="baseInfoComponent"
                            v-model="baseForm"
                            :internId="String(id)"
                            :page-type="$route.meta.pageType">
            </base-info-form>
            <el-form-item style="margin-top: 20px;">
              <el-button type="primary" @click="onSubmitBase()" :loading="baseLoading">保存基础资料</el-button>
              <el-button @click="$router.back()">返回</el-button>
            </el-form-item>
          </el-form>
        </layout-panel>
      </el-tab-pane>

      <!-- 隐私信息标签页 -->
      <el-tab-pane label="隐私信息"
                   name="privateInfo"
                   v-if="allowViewEditPrivate()">
        <layout-panel :show-header="false">
          <el-form ref="privateForm"
                   class="form-content-half"
                   :model="privateForm"
                   :rules="privateFormRules"
                   size="medium"
                   label-width="140px"
                   @submit.native.prevent="onSubmitPrivate()">
            <private-info-form ref="privateInfoComponent"
                               :internId="String(id)"
                               v-model="privateForm">
            </private-info-form>
            <el-form-item style="margin-top: 20px;">
              <el-button type="primary" @click="onSubmitPrivate()" :loading="privateLoading">保存隐私信息</el-button>
              <el-button @click="$router.back()">返回</el-button>
            </el-form-item>
          </el-form>
        </layout-panel>
      </el-tab-pane>

      <el-tab-pane label="资源控制"
                   name="resourceInfo"
                   v-if="allowViewEditResource()">
        <layout-panel :show-header="false">
          <el-form ref="resourceForm"
                   class="form-content-half"
                   :model="resourceForm"
                   size="medium"
                   label-width="140px"
                   @submit.native.prevent="onSubmitResource()">
            <resource-form ref="resourceComponent"
                           v-model="resourceForm">
            </resource-form>
            <el-form-item style="margin-top: 20px;">
              <el-button type="primary" @click="onSubmitResource()">保存资源控制</el-button>
              <el-button @click="$router.back()">返回</el-button>
            </el-form-item>
          </el-form>
        </layout-panel>
      </el-tab-pane>

      <el-tab-pane label="分配用户资源"
                   name="userResourceInfo"
                   v-if="allowViewEditUserResource()">
        <layout-panel :show-header="false">
          <userResourceLimitForm ref="userResourceComponent"
                                 :userid="id"
                                 :callbackAfterUpdate="afterUpdateUserSource"
                                 :key="id"/>
        </layout-panel>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { baseFormRules, privateFormRules } from '../audit-intern.rules.js'
import BaseInfoForm from '../components/BaseInfoForm.vue'
import PrivateInfoForm from '../components/PrivateInfoForm.vue'
import ResourceForm from '../components/ResourceForm.vue'
import { auditInternPermissionMixin } from '../audit-intern.mixins.js'
import userResourceLimitForm from '@views/platform-user-province/components/userResourceLimitForm.vue'

export default {
  components: {
    userResourceLimitForm,
    BaseInfoForm,
    PrivateInfoForm,
    ResourceForm,
  },
  mixins: [auditInternPermissionMixin],
  data () {
    return {
      id: 0,
      baseFormRules,
      privateFormRules,
      baseLoading: false,
      privateLoading: false,
      baseForm: {
        name: '',
        realname: '',
        employment_type: 1,
        status: 1,
        phone: '',
        mail_address: '',
        office_location: null,
        school: '',
        major: '',
        education_level: null,
        grade_level: null,
        contract_start_date: '',
        contract_end_date: '',
        remark: '',
        student_card_photos: []
      },
      privateForm: {
        id_number: '',
        id_card_front_photo: '',
        id_card_back_photo: '',
        bank_name: '',
        bank_branch_name: '',
        bank_card_number: '',
        bank_card_photo: []
      },
      resourceForm: {
        assign_customer_ids: [],
        ui_role_ids: [],
        api_role_ids: [],
      },
    }
  },
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  computed: {
    activeTab: {
      get () {
        return this.getActiveTab
      },
      set (val) {}
    }
  },
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([
      'queryInternTableApi'
    ]),
    onLoad () {
      if (this.$route.params.id) {
        this.setForm((this.id = this.$route.params.id))
      }
    },
    onReload () {
      // 重置路由查询参数，清除可能的file参数
      if (this.$route.query.file !== undefined) {
        this.$router.replace({
          path: this.$route.path,
          query: {}
        })
      }
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm (id) {
      if (this.allowViewEditBase() || this.allowViewEditResource()) {
        request.common('getInternBaseInfoApi', {id}).then(({data}) => {
          if (this.allowViewEditBase()) filter.setLoop(this.baseForm, data)

          if (this.allowViewEditResource()) {
            this.resourceForm.assign_customer_ids = data.assigned_customers.map(it => it.id)
            this.resourceForm.ui_role_ids = data.ui_roles.map(it => Number(it.id))
            this.resourceForm.api_role_ids = data.api_roles.map(it => Number(it.id))
          }
        })
      }
      if (this.allowViewEditPrivate()) {
        request.common('getInternPrivateInfoApi', {id}).then(({data}) => {
          filter.setLoop(this.privateForm, data)
        })
      }
    },
    onSubmitBase () {
      this.$refs['baseForm'].validate(valid => {
        if (valid) {
          this.baseLoading = true
          const params = { id: this.id, ...this.baseForm }
          params.education_level = params.education_level ? params.education_level : null
          params.grade_level = params.grade_level ? params.grade_level : null
          request
            .common('updateAuditInternBaseApi', params)
            .then(res => {
              this.$message.success('基础资料保存成功')
            })
            .finally(() => {
              this.baseLoading = false
            })
        } else {
          this.$message.error('基础资料填写不正确！')
        }
      })
    },
    onSubmitPrivate () {
      this.$refs['privateForm'].validate(valid => {
        if (valid) {
          this.privateLoading = true
          request
            .common('updateAuditInternPrivateApi', { id: this.id, ...this.privateForm })
            .then(res => {
              this.$message.success('隐私信息保存成功')
            })
            .finally(() => {
              this.privateLoading = false
            })
        } else {
          this.$message.error('隐私信息填写不正确！')
        }
      })
    },
    onSubmitResource () {
      this.$refs['resourceForm'].validate(valid => {
        if (valid) {
          request
            .common('updateAuditInternResourceApi', { id: this.id, ...this.resourceForm })
            .then(res => {
              this.$message.success('资源控制数据保存成功')
            })
        } else {
          this.$message.error('资源控制数据填写不正确！')
        }
      })
    },
    afterUpdateUserSource () {
      this.$message.success('用户资源分配成功')
    },
  }
}
</script>
<style lang="scss">
/* 所有表单项内容区域最大宽度50% */
.form-content-half .el-form-item__content {
  max-width: 50%;
}
</style>
<style lang="scss" scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss" module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>




// WEBPACK FOOTER //
// src/views/audit-intern/pages/AuditInternEditForm.vue